import { SelectContactModalProps } from './SelectContactModal';
import { openModal } from '@core/components/ModalStack';

export async function openSelectContactModal(props: SelectContactModalProps) {
  const { SelectContactModal } = await import('./SelectContactModal');

  openModal(SelectContactModal, props);
}
